export { default } from './Detail'



// WEBPACK FOOTER //
// ./src/Detail/index.js